<template>
  <div>
    <!-- 轮播图 -->
    <div class="banner">
      <img src="../assets/images/banner.jpg" alt="" class="banner-img">
    </div>
  </div>
</template>

<script>
export default {
  name: "Swiper",
  data() {
    return {
      images: [
        require("../assets/images/1.png"),
        require("../assets/images/2.png"),
        require("../assets/images/3.png"),
      ]
    };
    // <!-- 轮播图 -->
    // <van-swipe :autoplay="3000" class="banner">
    //   <van-swipe-item v-for="(image, index) in images" :key="index">
    //     <img  v-lazy="image" class="banner-img" />
    //   </van-swipe-item>
    // </van-swipe>
  }
};
</script>

<style>
.banner {
  width: 100%;
  height: 200px;
}
.banner .banner-img {
  display: block;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Swiper.vue